import { updatableListActions } from '../../GeneralListFunctions/actionFactory'
export default updatableListActions('USER_ORGANIZATION')
